import Menu from './Menu';

/**
 * KeyBoardEvents class.
 */
export default class KeyBoardEvents {
    constructor() {
        this.mobileMenu = document.getElementById( 'mobile-menu' );
        this.mobileMenuToggle = document.getElementById( 'menuToggle' );
        this.keyboardEvents();

        this.menu = new Menu();
    }

    /**
     * Firing the keyboard listeners.
     */
    keyboardEvents() {
        const self = this;

        window.addEventListener( "keyup", ( e ) => {
            const activeEl = document.activeElement;

            if ( 'Tab' === e.key && !activeEl.closest( '.menu' ) ) {
                if( !!activeEl?.parentNode?.parentNode?.querySelector('.menu') ) {
                    this.closeActiveSubmenus( activeEl.parentNode.parentNode.querySelector( '.menu' )?.children, activeEl );
                } else if( !e.composedPath().includes( document.getElementById( 'site-header' ) ) ) {
                    // Site Header menu's so no mobile-menu's!
                    const menus = document.getElementById( 'site-header' ).getElementsByClassName( 'menu' );
                    Array.from( menus ).forEach( menu => this.closeActiveSubmenus( menu?.children ) );
                }
            }

            // Toggle sub-menu.
            if ( !e.shiftKey
                && activeEl?.classList.contains( 'menu-item__toggle' )
                && ( ' ' === e.key || 'Space' === e.code || 'Enter' === e.key ) // 'Space' is just ' '.
            ) {
                // Check for other active submenu's
                this.closeActiveSubmenus( activeEl.parentNode.parentNode.children, activeEl.parentNode );

                // Open current.
                this.menu.updateSubMenu( activeEl.parentNode, activeEl.getAttribute( 'aria-expanded' ) !== 'true' );
            }

            // Close the current sub-menu or parent sub-menu when current is already closed.
            if ( !!e.isTrusted && 'Escape' === e.key ) {
                if ( !!activeEl.hasAttribute( 'aria-expanded' ) && 'true' === activeEl.getAttribute( 'aria-expanded' ) ) {
                    // Currently the activeMenu is the toggle.
                    this.menu.closeSubMenu( activeEl.parentNode, activeEl.parentNode.querySelector( '[aria-expanded="true"]' ) );
                } else if ( !!activeEl.parentNode.hasAttribute( 'aria-expanded' ) && 'true' === activeEl.parentNode.getAttribute( 'aria-expanded' ) ) {
                    this.menu.closeSubMenu( activeEl.parentNode, activeEl.parentNode.querySelector( '[aria-expanded="true"]' ) );
                } else if (activeEl.parentNode.parentNode.parentNode) {
                    this.menu.closeSubMenu( activeEl.parentNode.parentNode.parentNode, activeEl.parentNode.parentNode.parentNode.querySelector( '[aria-expanded="true"]' ) );
                }

                this.closeActiveSubmenus( activeEl.parentNode.parentNode.children, activeEl.parentNode );
            }

            // Go to the menu-item page.
            if ( !!e.isTrusted && 'Space' === e.code && activeEl.classList.contains( 'menu-item__link' ) ) {
                e.preventDefault();
                activeEl.click();
            }
        } );

        // For zoomed-in or resized desktops/laptops.
        if ( window.matchMedia( '(max-width: 991px)' ).matches ) {
            window.addEventListener( "keyup", ( e ) => {
                // Reset focus to toggle.
                if ( !!e.isTrusted && !e.ctrlKey && 'Tab' === e.key && !!self.activeMenu() ) {
                    self.focusBackToMobileToggle();
                }

                // Close the mobile-menu.
                if ( !!e.isTrusted && !e.ctrlKey && 'Escape' === e.key && !!self.activeMenu() ) {
                    self.closeMobileMenu();
                    self.mobileMenuToggle.focus();
                }
            } );
        }
    }

    /**
     * Returns boolean based on if mobile menu is active.
     * @return {boolean}
     */
    activeMenu() {
        return !!document.body.classList.contains( 'menu-active' );
    }

    /**
     * Set focus back to the mobileToggle when matching the last item.
     */
    focusBackToMobileToggle() {
        if ( !!this.mobileMenuToggle ) {
            const items = this.mobileMenu.querySelectorAll( '[tabindex="0"]' );
            if ( items[ items.length - 1 ] === document.activeElement ) {
                this.mobileMenuToggle.focus();
            }
        }
    }

    /**
     * Click the menu toggle, in the events() method there's already checked if it's open.
     */
    closeMobileMenu() {
        if ( !!this.mobileMenuToggle ) {
            this.mobileMenuToggle.click();
        }
    }

    /**
     * Close all active sub-menu's
     *
     * @param {HTMLCollection|Array} elements List of HTML elements.
     * @param {HTMLObjectElement} exception Specific HTML element.
     */
    closeActiveSubmenus( elements, exception ) {
        if( !!exception ) {
            Array.from( elements ).filter( el => el?.classList?.contains( 'menu-item-has-children' ) && el !== exception ).forEach( p => this.menu.closeSubMenu( p ) );
        } else {
            Array.from( elements ).filter( el => el?.classList?.contains( 'menu-item-has-children' ) ).forEach( p => this.menu.closeSubMenu( p ) );
        }
    }
}
